import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pencil } from "src/components/svg";
import { UserFavorite, UserFavoriteItem } from "src/models";
import SimpleBar from "simplebar-react";
import { ModalsAction, ProfileData, UserSession } from "src/store";
import { TeamChip } from "./team.chip";
import { SportChip } from "./sport.chip";

export const FavoriteRow: React.FC<UserFavorite> = (fav) => {
  //#region Dependencies

  const dispatch = useDispatch();
  const user: UserSession = useSelector((state: any) => state.UserState);
  const data: ProfileData = useSelector((state: any) => state.ProfileDataState);

  //#end region

  //#region props

  const { actionLoading, loading } = data.favorites;
  const { emptyIcon, _texts, items, title } = fav;
  const sportSelected =
    user.user?.profileCompleted &&
    (fav.itemType === "Sport" ||
      data.favorites.list.some(
        (x) => x.itemType === "Sport" && x.items.length
      ));

  //#end region

  //#region methods

  const onEdit = () => {
    if (!user.user?.profileCompleted) {
      dispatch(ModalsAction.showProfile());
      return;
    }

    if (!sportSelected) {
      dispatch(ModalsAction.showFavoritesNoSport());
      return;
    }

    dispatch(ModalsAction.showFavorites(fav));
  };

  //#end region

  //#region helpers

  const renderEmpty = () => (
    <div className=" d-flex align-items-center py-3 px-3 px-md-0">
      <img className="empty-icon" alt="" src={emptyIcon} />
      <h3 className="empty-message">{_texts.emptyMessage}</h3>
    </div>
  );

  const renderSportTeamItem = (item: UserFavoriteItem, index: number) => {
    if (fav.itemType === "Team")
      return <TeamChip key={item.sport + item.team} {...item} />;
    return <SportChip key={item.sport} {...item} />;
  };

  //#end region

  return (
    <div className="favorite-row">
      <div className="favorite-header px-2 px-md-0 d-flex justify-content-between align-items-center">
        <h3 className="profile-sub-title">{title}</h3>
        <button
          disabled={actionLoading || loading}
          onClick={onEdit}
          className={`btn btn-edit-favorite${
            sportSelected ? "" : " unavailable"
          }`}
        >
          <Pencil />
          {fav._texts.edit}
        </button>
      </div>
      {!items?.length && renderEmpty()}
      <SimpleBar style={{ maxWidth: "100%" }} dir="rtl">
        <div className="d-flex py-2">
          {!!items.length &&
            items.map((x, index) => renderSportTeamItem(x, index))}
        </div>
      </SimpleBar>
    </div>
  );
};
